export default function LiveWaitingListTable({ data }) {
  const lastUpdated = new Date(data[0].updated_at);
  const lastUpdatedString = lastUpdated.toLocaleString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZoneName: 'short',
  });

  return (
    <section aria-labelledby="live-waiting-list-heading" className="">
      <div className="vstack gap-3 bg-white p-3 rounded">
        <h3 id="live-waiting-list-heading" className="h4 mb-0 text-primary">
          Live Waiting List
        </h3>

        <table className='table table-responsive table-bordered m-0' style={{'--bs-table-bg': 'transparent'}}>
          <thead>
            <tr>
              <th scope="col" className="subhead-3 text-primary">Name</th>
              <th scope="col" className="text-center subhead-3 text-gray">Tables</th>
              <th scope="col" className="text-center subhead-3 text-gray">Waiting</th>
            </tr>
          </thead>

          <tbody>
            {data.map((game) => (
              <tr key={game.id}>
                <td className="fw-medium">{game.game_name}</td>
                <td className="text-center">{game.tables}</td>
                <td className="text-center">{game.waiting}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="text-center fw-normal text-dark">
          {/*<p>Download the <a href="https://www.pokeratlas.com/info/mobile" rel="noindex nofollow" target='_blank'>Poker Atlas App</a> to check the action from anywhere.</p>*/}
          <p className="mb-0">Last updated {lastUpdatedString}</p>
        </div>
      </div>
    </section>
  )
}
